export interface QueryParameters {
    query: string;
}

//Hittar värdet av parametern , exempel "q" som argument ger "querystring" när man söker igenom en google search url.

export function queryFilter(param: QueryParameters) {
    this.param = param;
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0].toLocaleLowerCase() == this.param.toLocaleLowerCase()) {
            return pair[1];
        }
    }
    return undefined;
}
